import { Box } from '@mui/material';
import { FC } from 'react';
import { useGetTitle } from '../../hooks';
import { ResponsiveText } from '../responsive-text';

export const PageTitle: FC<{ defaultValue: string }> = ({ defaultValue }) => {
  const { title, replace } = useGetTitle();

  const displayText = title ?? defaultValue;

  if (replace) return <>{displayText}</>;
  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flex: 1, maxWidth: 'calc(100% - 40px)' }}>
      <ResponsiveText
        variant="h6"
        responsiveOptions={{
          minFontSize: '1rem',
          maxFontSize: '1.25rem',
          textLengthThreshold: 20,
        }}
        data-testid="page-title"
      >
        {displayText}
      </ResponsiveText>
    </Box>
  );
};
